// packages/ag-charts-locale/src/vi-VN.ts
var AG_CHARTS_LOCALE_VI_VN = {
  ariaAnnounceChart: "bi\u1EC3u \u0111\u1ED3, ${seriesCount}[number] chu\u1ED7i",
  ariaAnnounceFlowProportionLink: "li\xEAn k\u1EBFt ${index} c\u1EE7a ${count}, t\u1EEB ${from} \u0111\u1EBFn ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "n\xFAt ${index} c\u1EE7a ${count}, ${description}",
  ariaAnnounceGaugeChart: "bi\u1EC3u \u0111\u1ED3 \u0111\u1ED3ng h\u1ED3 \u0111o, ${caption}",
  ariaAnnounceHierarchyChart: "bi\u1EC3u \u0111\u1ED3 ph\xE2n c\u1EA5p, ${caption}",
  ariaAnnounceHierarchyDatum: "c\u1EA5p \u0111\u1ED9 ${level}[number], ${count}[number] con, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Nh\u1EA5n Ph\xEDm C\xE1ch ho\u1EB7c Enter \u0111\u1EC3 chuy\u1EC3n \u0111\u1ED5i ch\u1EBF \u0111\u1ED9 hi\u1EC3n th\u1ECB",
  ariaLabelAddHorizontalLine: "Th\xEAm \u0110\u01B0\u1EDDng Ngang",
  ariaLabelAnnotationOptionsToolbar: "T\xF9y ch\u1ECDn Ch\xFA th\xEDch",
  ariaLabelAnnotationSettingsDialog: "C\xE0i \u0111\u1EB7t Ch\xFA th\xEDch",
  ariaLabelColorPicker: "Tr\xECnh ch\u1ECDn m\xE0u",
  ariaLabelFinancialCharts: "Bi\u1EC3u \u0111\u1ED3 t\xE0i ch\xEDnh",
  ariaLabelLegend: "Ch\xFA gi\u1EA3i",
  ariaLabelLegendItem: "${label}, M\u1EE5c ch\xFA gi\u1EA3i ${index}[number] c\u1EE7a ${count}[number]",
  ariaLabelLegendItemUnknown: "M\u1EE5c ch\xFA gi\u1EA3i kh\xF4ng x\xE1c \u0111\u1ECBnh",
  ariaLabelLegendPageNext: "Trang Ch\xFA Gi\u1EA3i Ti\u1EBFp Theo",
  ariaLabelLegendPagePrevious: "Trang Huy\u1EC1n Tho\u1EA1i Tr\u01B0\u1EDBc",
  ariaLabelLegendPagination: "Ph\xE2n trang Ch\xFA gi\u1EA3i",
  ariaLabelNavigator: "Tr\xECnh \u0111i\u1EC1u h\u01B0\u1EDBng",
  ariaLabelNavigatorMaximum: "T\u1ED1i \u0111a",
  ariaLabelNavigatorMinimum: "T\u1ED1i thi\u1EC3u",
  ariaLabelNavigatorRange: "Ph\u1EA1m vi",
  ariaLabelRangesToolbar: "Ph\u1EA1m vi",
  ariaLabelSettingsTabBar: "C\xE0i \u0111\u1EB7t",
  ariaLabelZoomToolbar: "Thu ph\xF3ng",
  ariaValuePanRange: "${min}[percent0to2dp] \u0111\u1EBFn ${max}[percent0to2dp]",
  contextMenuDownload: "T\u1EA3i v\u1EC1",
  contextMenuPanToCursor: "Chuy\u1EC3n \u0111\u1EBFn \u0111\xE2y",
  contextMenuToggleOtherSeries: "Chuy\u1EC3n \u0111\u1ED5i c\xE1c d\xF2ng kh\xE1c",
  contextMenuToggleSeriesVisibility: "Chuy\u1EC3n \u0111\u1ED5i Hi\u1EC3n th\u1ECB",
  contextMenuZoomToCursor: "Thu ph\xF3ng t\u1EDBi \u0111\xE2y",
  dialogHeaderChannel: "K\xEAnh",
  dialogHeaderDatePriceRange: "Ng\xE0y v\xE0 Gi\xE1",
  dialogHeaderDateRange: "Kho\u1EA3ng th\u1EDDi gian",
  dialogHeaderFibonacciRange: "Fib H\u1ED3i Quy",
  dialogHeaderLine: "\u0110\u01B0\u1EDDng k\u1EBB",
  dialogHeaderPriceRange: "Kho\u1EA3ng Gi\xE1",
  dialogHeaderText: "V\u0103n b\u1EA3n",
  dialogInputAlign: "C\u0103n ch\u1EC9nh",
  dialogInputColorPicker: "M\xE0u s\u1EAFc",
  dialogInputColorPickerAltText: "M\xE0u ch\u1EEF",
  dialogInputExtendAbove: "M\u1EDF r\u1ED9ng l\xEAn tr\xEAn",
  dialogInputExtendBelow: "M\u1EDF r\u1ED9ng xu\u1ED1ng d\u01B0\u1EDBi",
  dialogInputExtendChannelEnd: "K\xE9o d\xE0i cu\u1ED1i k\xEAnh",
  dialogInputExtendChannelStart: "M\u1EDF r\u1ED9ng k\xEAnh b\u1EAFt \u0111\u1EA7u",
  dialogInputExtendLeft: "K\xE9o d\xE0i sang tr\xE1i",
  dialogInputExtendLineEnd: "M\u1EDF r\u1ED9ng cu\u1ED1i d\xF2ng",
  dialogInputExtendLineStart: "K\xE9o d\xE0i \u0111i\u1EC3m b\u1EAFt \u0111\u1EA7u \u0111\u01B0\u1EDDng th\u1EB3ng",
  dialogInputExtendRight: "M\u1EDF r\u1ED9ng sang ph\u1EA3i",
  dialogInputFibonacciBands: "D\u1EA3i",
  dialogInputFibonacciBandsAltText: "D\u1EA3i Fibonacci",
  dialogInputFillColorPicker: "T\xF4 m\xE0u",
  dialogInputFillColorPickerAltText: "M\xE0u t\xF4",
  dialogInputFontSize: "K\xEDch th\u01B0\u1EDBc",
  dialogInputFontSizeAltText: "K\xEDch Th\u01B0\u1EDBc Ch\u1EEF",
  dialogInputLineStyle: "G\u1EA1ch n\u1ED1i",
  dialogInputPosition: "V\u1ECB tr\xED",
  dialogInputReverse: "\u0110\u1EA3o ng\u01B0\u1EE3c",
  dialogInputShowFill: "Hi\u1EC7n \u0110i\u1EC1n",
  dialogInputStrokeWidth: "\u0110\u1ED9 d\xE0y",
  dialogInputStrokeWidthAltText: "\u0110\u1ED9 d\xE0y \u0111\u01B0\u1EDDng k\u1EBB",
  iconAltTextAlignCenter: "C\u0103n gi\u1EEFa",
  iconAltTextAlignLeft: "Tr\xE1i",
  iconAltTextAlignRight: "Ph\u1EA3i",
  iconAltTextClose: "\u0110\xF3ng",
  iconAltTextLineStyleDashed: "G\u1EA1ch ngang d\xE0i",
  iconAltTextLineStyleDotted: "G\u1EA1ch ng\u1EAFn",
  iconAltTextLineStyleSolid: "Li\u1EC1n m\u1EA1ch",
  iconAltTextPositionBottom: "D\u01B0\u1EDBi c\xF9ng",
  iconAltTextPositionCenter: "Gi\u1EEFa",
  iconAltTextPositionTop: "Tr\xEAn c\xF9ng",
  inputTextareaPlaceholder: "Th\xEAm V\u0103n B\u1EA3n",
  measurerDateRangeBars: "${value}[number] thanh",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Th\u1EC3 t\xEDch ${value}",
  overlayLoadingData: "\u0110ang t\u1EA3i d\u1EEF li\u1EC7u...",
  overlayNoData: "Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u \u0111\u1EC3 hi\u1EC3n th\u1ECB",
  overlayNoVisibleSeries: "Kh\xF4ng c\xF3 d\xE3y s\u1ED1 hi\u1EC3n th\u1ECB",
  overlayUnsupportedBrowser: "Phi\xEAn b\u1EA3n tr\xECnh duy\u1EC7t kh\xF4ng t\u01B0\u01A1ng th\xEDch. Vui l\xF2ng n\xE2ng c\u1EA5p tr\xECnh duy\u1EC7t c\u1EE7a b\u1EA1n.",
  seriesHistogramTooltipCount: "${yName} (s\u1ED1 \u0111\u1EBFm)",
  seriesHistogramTooltipFrequency: "T\u1EA7n su\u1EA5t",
  seriesHistogramTooltipMean: "${yName} (trung b\xECnh)",
  seriesHistogramTooltipSum: "${yName} (t\u1ED5ng)",
  toolbarAnnotationsArrow: "M\u0169i t\xEAn",
  toolbarAnnotationsArrowDown: "M\u0169i t\xEAn xu\u1ED1ng",
  toolbarAnnotationsArrowUp: "M\u0169i t\xEAn l\xEAn",
  toolbarAnnotationsCallout: "Ch\xFA th\xEDch",
  toolbarAnnotationsClearAll: "X\xF3a t\u1EA5t c\u1EA3",
  toolbarAnnotationsComment: "B\xECnh lu\u1EADn",
  toolbarAnnotationsDatePriceRange: "Ng\xE0y v\xE0 Gi\xE1",
  toolbarAnnotationsDateRange: "Kho\u1EA3ng th\u1EDDi gian",
  toolbarAnnotationsDelete: "X\xF3a",
  toolbarAnnotationsDisjointChannel: "K\xEAnh kh\xF4ng li\xEAn t\u1EE5c",
  toolbarAnnotationsDragHandle: "K\xE9o Thanh C\xF4ng C\u1EE5",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Ph\u1EE5c h\u1ED3i",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u0110\u01B0\u1EDDng xu h\u01B0\u1EDBng d\u1EF1a tr\xEAn Fibonacci",
  toolbarAnnotationsFillColor: "M\xE0u n\u1EC1n",
  toolbarAnnotationsHorizontalLine: "\u0110\u01B0\u1EDDng Ngang",
  toolbarAnnotationsLineAnnotations: "\u0110\u01B0\u1EDDng Xu H\u01B0\u1EDBng",
  toolbarAnnotationsLineColor: "M\xE0u \u0110\u01B0\u1EDDng",
  toolbarAnnotationsLineStrokeWidth: "\u0110\u1ED9 r\u1ED9ng n\xE9t v\u1EBD",
  toolbarAnnotationsLineStyle: "Ki\u1EC3u \u0110\u01B0\u1EDDng",
  toolbarAnnotationsLock: "Kh\xF3a",
  toolbarAnnotationsMeasurerAnnotations: "C\xF4ng c\u1EE5 \u0111o l\u01B0\u1EDDng",
  toolbarAnnotationsNote: "Ghi ch\xFA",
  toolbarAnnotationsParallelChannel: "K\xEAnh Song Song",
  toolbarAnnotationsPriceRange: "Kho\u1EA3ng Gi\xE1",
  toolbarAnnotationsQuickDatePriceRange: "\u0110o l\u01B0\u1EDDng",
  toolbarAnnotationsSettings: "C\xE0i \u0111\u1EB7t",
  toolbarAnnotationsShapeAnnotations: "M\u0169i t\xEAn",
  toolbarAnnotationsText: "V\u0103n b\u1EA3n",
  toolbarAnnotationsTextAnnotations: "Ch\xFA th\xEDch v\u0103n b\u1EA3n",
  toolbarAnnotationsTextColor: "M\xE0u ch\u1EEF",
  toolbarAnnotationsTextSize: "K\xEDch Th\u01B0\u1EDBc V\u0103n B\u1EA3n",
  toolbarAnnotationsTrendLine: "\u0110\u01B0\u1EDDng xu h\u01B0\u1EDBng",
  toolbarAnnotationsUnlock: "M\u1EDF kh\xF3a",
  toolbarAnnotationsVerticalLine: "\u0110\u01B0\u1EDDng th\u1EB3ng \u0111\u1EE9ng",
  toolbarRange1Month: "1T",
  toolbarRange1MonthAria: "1 th\xE1ng",
  toolbarRange1Year: "1N",
  toolbarRange1YearAria: "1 n\u0103m",
  toolbarRange3Months: "3 Th\xE1ng",
  toolbarRange3MonthsAria: "3 th\xE1ng",
  toolbarRange6Months: "6T",
  toolbarRange6MonthsAria: "6 th\xE1ng",
  toolbarRangeAll: "T\u1EA5t c\u1EA3",
  toolbarRangeAllAria: "T\u1EA5t c\u1EA3",
  toolbarRangeYearToDate: "T\u1EEB \u0111\u1EA7u n\u0103m \u0111\u1EBFn nay",
  toolbarRangeYearToDateAria: "T\u1EEB \u0111\u1EA7u n\u0103m \u0111\u1EBFn nay",
  toolbarSeriesTypeCandles: "N\u1EBFn",
  toolbarSeriesTypeDropdown: "Lo\u1EA1i Bi\u1EC3u \u0110\u1ED3",
  toolbarSeriesTypeHighLow: "Cao Th\u1EA5p",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "N\u1EBFn R\u1ED7ng",
  toolbarSeriesTypeLine: "\u0110\u01B0\u1EDDng",
  toolbarSeriesTypeLineWithMarkers: "\u0110\u01B0\u1EDDng c\xF3 \u0111i\u1EC3m \u0111\xE1nh d\u1EA5u",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u0110\u01B0\u1EDDng b\u1EADc thang",
  toolbarZoomPanEnd: "Di chuy\u1EC3n \u0111\u1EBFn cu\u1ED1i",
  toolbarZoomPanLeft: "Di chuy\u1EC3n sang tr\xE1i",
  toolbarZoomPanRight: "Di chuy\u1EC3n sang ph\u1EA3i",
  toolbarZoomPanStart: "Di chuy\u1EC3n ngang tr\u1EDF l\u1EA1i \u0111\u1EA7u trang",
  toolbarZoomReset: "\u0110\u1EB7t l\u1EA1i thu ph\xF3ng",
  toolbarZoomZoomIn: "Thu nh\u1ECF",
  toolbarZoomZoomOut: "Thu nh\u1ECF",
  tooltipPaginationStatus: "${index}[number] trong s\u1ED1 ${count}[number]"
};
export {
  AG_CHARTS_LOCALE_VI_VN
};
//# sourceMappingURL=vi-VN.esm.mjs.map
